import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pendingContracts: {},
  activeContracts: {},
  terminationRequests: {},
  refreshList: false,
};

const musharkaContractSlice = createSlice({
  name: "musharkaContracts",
  initialState,
  reducers: {
    addMusharkaContracts: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data; // name: "pendingContracts" or "activeContracts"
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default musharkaContractSlice;
export const { addMusharkaContracts, isRefreshList } =
  musharkaContractSlice.actions;
